import styled from 'styled-components';
import { blueColor } from 'js/config/style';

export default styled.div`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  cursor: pointer;
  user-select: none;

  background: ${({ color }) => color || blueColor};
  color: white;
  font-weight: 500;

  &:hover {
    background: ${blueColor.darken(0.5)};
  }
  &:active {
    background: ${blueColor.darken(1)};
    box-shadow: 0 1px 3px -1px black inset;
  }
`;
